export default "__VITE_ASSET__E2c1zd1$__"